// Khan Academy-inspired subject palette, keyed by chapter index (1..N)
export const CHAPTER_COLORS = [
    '#1865F2', // 1. Math blue
    '#1FAB54', // 2. Science green
    '#9059FF', // 3. Computing purple
    '#E07D10', // 4. Arts gold
    '#11ACCD', // 5. Reading teal
    '#CA337C', // 6. Humanities pink
    '#0A5A9C', // 7. Economics deep blue
    '#A75A05', // 8. Test prep brown
];

// Mapping from top-level training slug -> palette index, so sub-pages match
// the color of their parent chapter card on the Training index page.
// Indices reflect the actual chapter INDEX shown as "UNIT NN" on /training.
export const SLUG_TO_COLOR_INDEX = {
    'brokerage-continuum': 1,            // blue   (UNIT 01)
    'administration': 2,                 // green  (UNIT 02)
    'tips-of-the-trade-and-inspiration': 3, // purple (UNIT 03)
    'events': 4,                         // gold   (UNIT 04)
    'roles-and-responsibilities': 5,    // teal   (UNIT 05)
    'business-planning': 6,             // pink   (UNIT 06)
    'strive-pillars': 7,                // deep blue (UNIT 07)
};

export const getChapterColorByIndex = (index) =>
    CHAPTER_COLORS[(((index || 1) - 1) % CHAPTER_COLORS.length + CHAPTER_COLORS.length) % CHAPTER_COLORS.length];

export const getChapterColorBySlug = (slug) =>
    getChapterColorByIndex(SLUG_TO_COLOR_INDEX[slug] || 1);
